import * as t from "io-ts";

export const Approval = t.intersection([
  t.type({
    outcome: t.union([
      t.literal("PASS"),
      t.literal("REVIEW"),
      t.literal("FAIL"),
    ]),
    reason: t.union([
      t.literal("approved"),
      t.literal("insufficient_details"),
      t.literal("invalid_details"),
      t.literal("mismatched_details"),
      t.literal("investigation_required"),
      t.literal("manual_review_required"),
      t.literal("not_approved"),
      t.literal("not_approved_ccj_against_business_or_director"),
      t.literal("not_approved_ccj_against_previous_association"),
      t.literal("not_approved_listed_trade_type_not_covered"),
      t.literal("not_approved_several_negatives_against_company"),
    ]),
  }),
  t.partial({
    reason_note: t.string,
  }),
]);

export interface Approval {
  outcome: "PASS" | "REVIEW" | "FAIL";
  reason:
    | "approved"
    | "insufficient_details"
    | "invalid_details"
    | "mismatched_details"
    | "investigation_required"
    | "manual_review_required"
    | "not_approved"
    | "not_approved_ccj_against_business_or_director"
    | "not_approved_ccj_against_previous_association"
    | "not_approved_listed_trade_type_not_covered"
    | "not_approved_several_negatives_against_company";
  reason_note?: string;
}
